import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ModalService } from '@app/core/services/modal.service';
import { ComponentBaseComponent } from '@app/core/components/component-base/component-base.component';
import { Base64UrlService } from '@app/services/base64url.service';
import { DoDataImpGet, DoDataImpService } from '@app/services/do-data-imp.service';

@Component({
    selector: 'tt-do-data-imp-import-dialog',
    templateUrl: './do-data-imp-import-dialog.component.html',
    styleUrls: ['./do-data-imp-import-dialog.component.css'],
})
export class DoDataImpImportDialogComponent extends ComponentBaseComponent {
    public filename: string = '';

    public headers: { value: any; index: number }[] = [];

    public data: { [key: string]: string }[] = [];

    constructor(@Inject(MAT_DIALOG_DATA) private get: DoDataImpGet, public dialogRef: MatDialogRef<DoDataImpImportDialogComponent>, private modal: ModalService, private doDataImp: DoDataImpService, private base64: Base64UrlService) {
        super();
    }

    public async import() {
        if (!this.filename) return;

        const headers = this.headers.map((header) => header.value);
        const data = this.data.map((row) => Object.values(row).join('|§|')).join('|#|');

        const { exec_resultcode, exec_message } = await this.doDataImp.importFromExcel({ headerdata: this.base64.Encode(JSON.stringify(headers)), records: this.base64.urlEncode(data), table_name_destination: this.get.table_name_destination });

        if ('' + exec_resultcode < '0') {
            this.modal.show({ type: 'warning', title: 'error', translateTitle: true, message: exec_message });
        } else {
            this.dialogRef.close(true);
        }
    }
}
